import React from 'react';
import Lottie from '../ReactLottie';
import animationData from './animationData';

const requireContextImages = () => {
  const lottieImagesRequire = require.context(
    '@/assets/images/lottie/loadingProfessor/',
    false,
    /\w+\.png$/,
  );
  return lottieImagesRequire.keys().map(e => lottieImagesRequire(e));
};

class LoadingProfessor extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      isStopped: true,
    };
    this.lottie = React.createRef();
  }

  componentDidMount() {
    setTimeout(() => this.setState({ isStopped: false }), 0);
    // 点击暂停
    this.lottie.current.handleClickToPause = null;
  }

  render() {
    const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      },
    };
    const lottieStyles = {
      margin: '0 auto',
      width: '100%',
      height: '100%',
    };
    const eventListeners = [
      {
        eventName: 'complete',
      },
    ];
    return (
      <Lottie
        ref={this.lottie}
        style={lottieStyles}
        options={defaultOptions}
        requireContextImages={requireContextImages}
        isStopped={this.state.isStopped}
        eventListeners={eventListeners}
      />
    );
  }
}

export default LoadingProfessor;
